import Text from 'components/Text/Text';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from '../../../../../deviceFullInfoState/deviceFullInfoContext';
import React, { useContext } from 'react';
import style from './TerminalIdField.module.scss';

const TerminalIdField: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	return (
		<div className={style.container} data-test="terminalIdLabel">
			<Text translationNameSpace="form" translationKey="terminalIdLabel" theme="neutralLight" size="xs" />
			<div className={style.restaurantsList}>
				{deviceForFullInfo?.deviceBankSettings.length
					? deviceForFullInfo.deviceBankSettings.map((el) => {
							return (
								<div key={el.id} className={style.item}>
									{deviceForFullInfo.deviceBankSettings.length > 1 && <div className={style.dot} />}
									<Text
										translationKey={`${el.restaurantBankSetting.acquirerName} / ${el.terminalId}`}
										size="s"
										withTooltip={true}
									/>
								</div>
							);
					  })
					: '-'}
			</div>
		</div>
	);
};

export default TerminalIdField;
